exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_filterSearchBoxContainer__2em71{width:320px}", ""]);

// exports
exports.locals = {
	"filterSearchBoxContainer": "style_filterSearchBoxContainer__2em71"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/areas/projects/components/ActionTemplateSelector/style.less
// module id = 2000
// module chunks = 8